'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DialogCloseButtonStyled = undefined;

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _reactackleCore = require('reactackle-core');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var propTypes = {
  transparentBg: _propTypes2.default.bool
};

var defaultProps = {
  transparentBg: false
};

/** Prop Receivers */
var sizeProps = function sizeProps(_ref) {
  var themeFromProvider = _ref.theme;

  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
  var _theme$reactackle$com = theme.reactackle.components.dialog.closeButton,
      width = _theme$reactackle$com.width,
      height = _theme$reactackle$com.height,
      imgSize = _theme$reactackle$com.imgSize;


  return (0, _styledComponents.css)(['     ', ''], (0, _reactackleCore.iconSizeMixin)((0, _reactackleCore.getValueString)(width), (0, _reactackleCore.getValueString)(imgSize || width), (0, _reactackleCore.getValueString)(height || width)));
};

var styleProps = function styleProps(_ref2) {
  var themeFromProvider = _ref2.theme,
      transparentBg = _ref2.transparentBg;

  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
  var path = theme.reactackle.components.dialog.closeButton.style,
      source = transparentBg ? path.modalWithTransparentBg : path;

  return '\n    color: ' + source.color + ';\n    opacity: ' + source.opacity + ';\n\n    &:hover {\n      color: ' + source.hover.color + ';\n      opacity: ' + source.hover.opacity + ';\n    }\n\n    &:focus {\n      color: ' + source.focus.color + ';\n      opacity: ' + source.focus.opacity + ';\n    }\n  ';
};

/** Styles */
var DialogCloseButtonStyled = exports.DialogCloseButtonStyled = _styledComponents2.default.div.withConfig({
  displayName: 'DialogCloseButtonStyled'
})(['position:absolute;top:0;right:0;display:flex;z-index:9;cursor:pointer;', ' ', ' ', ';'], sizeProps, styleProps, (0, _reactackleCore.transition)('color, opacity'));

DialogCloseButtonStyled.propTypes = propTypes;
DialogCloseButtonStyled.defaultProps = defaultProps;
DialogCloseButtonStyled.displayName = 'DialogCloseButtonStyled';


//////////////////
// WEBPACK FOOTER
// ./~/reactackle-dialog/dist/DialogCloseButton/styles/DialogCloseButtonStyled.js
// module id = 651
// module chunks = 0